const pbxListToMap = (destination, pbxList) => {
  const result = { ...destination };

  result.pbxMap = {};
  for (const item of pbxList) {
    const id = item?.id;
    const name = item?.name;
    if (!id) {
      throw new Error("PBX with no id found in Vue customer data.");
    }

    result.pbxMap[id] = name;
  }

  return result;
};

const adminListToPrimaryAdmin = (destination, adminLoginList) => {
  const result = { ...destination };
  result.primaryAdministrator = {};
  const vuePrimaryAdminLoginId = adminLoginList?.[0] ?? null;

  if (!vuePrimaryAdminLoginId) {
    console.warn("React received customer with null primary admin from Vue.");
    result.primaryAdministrator = null;
    return result;
  }

  result.primaryAdministrator = {
    loginId: vuePrimaryAdminLoginId,
  };
  return result;
};

const mapToReactCustomerData = (source) => {
  let result = {};
  result.customerId = source?.customerId ?? source?.cid;
  result.customerName = source?.customerName;
  result = pbxListToMap(result, source?.pbxList ?? []);
  result = adminListToPrimaryAdmin(result, source?.adminList ?? []);
  // TODO: Make sure tenantData is the same format as tenantInfo on the
  //  new backend.
  result.tenantData = source?.tenantInfo ?? null;

  // Setting "preselectedPbxId" will have this option show in the React dialog
  // as the preselected PBX option. Otherwise, there will be no value there.
  result.preselectedPbxId = (source?.pbxList ?? [])?.[0]?.id;

  return result;
};

export default mapToReactCustomerData;
